import { pokemonImgUrl } from '../lib/pokemonSlugs'
import styles from './report.module.css'

export function Avatar({
  pokemonId,
  profileColor,
  username,
  size,
}: {
  pokemonId: number
  profileColor: string
  username: string
  size?: number
}) {
  const src = pokemonImgUrl(pokemonId)
  return (
    <span
      className={styles.avatar}
      style={{
        backgroundColor: profileColor,
        ...(size ? { width: size, height: size } : {}),
      }}
      aria-hidden
    >
      {src ? <img src={src} alt={`${username}'s avatar`} loading="lazy" /> : null}
    </span>
  )
}
